//#region import libraries
import React, { useState, useEffect } from 'react';
//bootstrap
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
//validator
import validator from 'validator';
//custom components
import { CustomModal } from '_molecules';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectContactStatus, postMessage } from '_redux/slices/website/contact';
//styles
import { Colors, Spacing } from '_styles';
//#endregion

// contact us page in booking confirmation
const Contact = (props) => {
    //#region local state
    // state variables for form
    const [firstName, setFirstName] = useState("");
    const [secondName, setSecondName] = useState("");
    const [email, setEmail] = useState("");
    const [airportName, setAirportName] = useState("");
    const [message, setMessage] = useState("");
    const [submitted, setSubmitted] = useState(false);

    // form errors
    const [errors, setErrors] = useState({});

    // modals
    const [show, setShow] = useState(false);
    const [showAlready, setShowAlready] = useState(false);
    const [showError, setShowError] = useState(false);

    //#endregion

    //#region redux variables
    const dispatch = useDispatch();
    const status = useSelector(selectContactStatus);
    //#endregion

    //#region functions
    // handle message submission
    const handleSubmission = () => {
        // check if already submitted
        if (submitted == true && status == 'succeeded') {
            setShowAlready(true);
            return
        }

        // hold error messages
        let errors = {};

        // first name 
        if (firstName.length == 0) {
            errors.firstName = "First name required";
        }
        // second name
        if (secondName.length == 0) {
            errors.secondName = "Second name required";
        }
        // email
        if (!validator.isEmail(email)) {
            errors.email = "Valid email required";
        }
        // airport name
        if (airportName.length == 0) {
            errors.airport = "Valid airport required";
        }
        // message
        if (message.length == 0 || message.length < 5) {
            errors.message = "Valid message required";
        }

        // set errors
        setErrors(errors)

        // check all cases
        if (firstName.length != 0 && secondName.length != 0 && validator.isEmail(email) && airportName.length != 0 && (message.length != 0 && message.length > 5)) {
            setSubmitted(true)
            dispatch(postMessage({
                name: firstName + ' ' + secondName,
                email: email,
                company: airportName,
                message: message
            }));
        }

        return;
    }

    // handle done click on modal
    const handleDone = () => {
        setShow(false)
        // reroute back to booking page
        props.setPage("booking")
    }
    //#endregion

    //#region useEffects
    // check for status change on contact
    useEffect(() => {
        // successful submission
        if (status == 'succeeded' && submitted == true) {
            // show success message
            setShow(true)
        }
        // failed submission
        if (status == 'failed' && submitted == true) {
            setShowError(true);
        }
    }, [status]);
    //#endregion


    return (
        <>
            <Container fluid={true}>
                <Row>
                    <Col className="vh-100">

                        {/* Title */}
                        <Container className="mt-5">
                            <p style={{ fontSize: 26, fontWeight: 'bold' }}>Contact us</p>

                            <div className="mt-3">
                                <p style={{ fontSize: 18, fontWeight: '600', opacity: 0.6 }}>If you have any queries please contact us through the following form and we will respond as quickly as possible</p>
                            </div>
                        </Container>

                        {/* Forum */}
                        <Container className="mt-5">
                            <Form style={{ marginRight: Spacing.SCALE_200 }}>

                                {/* Name */}
                                <Form.Group>
                                    <Row>
                                        <Col>
                                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>First Name</Form.Label>
                                            <Form.Control placeholder="First" type="text" onChange={(e) => setFirstName(e.target.value)} />
                                            {errors.firstName && (<p className="text-danger">{errors.firstName}</p>)}
                                        </Col>
                                        <Col>
                                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Second Name</Form.Label>
                                            <Form.Control placeholder="Surname" type="text" onChange={(e) => setSecondName(e.target.value)} />
                                            {errors.secondName && (<p className="text-danger">{errors.secondName}</p>)}
                                        </Col>
                                    </Row>
                                </Form.Group>

                                {/* Email */}
                                <Form.Group className="mb-3 mt-3" controlId="formEmail">
                                    <Row>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Email</Form.Label>
                                        <Col>
                                            <Form.Control type="text" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
                                            {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                        </Col>
                                    </Row>
                                </Form.Group>

                                {/* Airport Name */}
                                <Form.Group>
                                    <Row>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Airport Name</Form.Label>
                                        <Col>
                                            <Form.Control type="text" onChange={(e) => setAirportName(e.target.value)} placeholder={"Enter your airport name"} />
                                            {errors.airport && (<p className="text-danger">{errors.airport}</p>)}
                                        </Col>
                                    </Row>
                                </Form.Group>

                                {/* Message */}
                                <Form.Group className="mt-4">
                                    <Row>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Message</Form.Label>
                                        <Col>
                                            <Form.Control as="textarea" style={{ height: '100px' }} type="text" placeholder="Type your message here..." onChange={(e) => setMessage(e.target.value)} />
                                            {errors.message && (<p className="text-danger">{errors.message}</p>)}
                                        </Col>
                                    </Row>
                                </Form.Group>

                                {/* Submit Button */}
                                <Container className="mt-5 justify-content-md-center d-inline-flex">
                                    <Button
                                        variant={(status == 'succeeded' && submitted == true) ? 'outline-success' : 'outline-primary'}
                                        onClick={handleSubmission}
                                        loading={true}
                                        style={{ width: 175 }}>

                                        {
                                            (status == 'succeeded' && submitted == true) ?
                                                'Successfully Submitted'
                                                :
                                                status != 'loading' ? 'Submit'
                                                    :
                                                    (<>
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                        <span className="visually-hidden">Loading...</span>
                                                    </>)}
                                    </Button>
                                    {errors.accountCreation && (<p className="text-danger">{errors.errorMessage}</p>)}
                                </Container>

                            </Form>
                        </Container>

                    </Col>
                </Row>

                {/* Success Modal */}
                <CustomModal
                    hide={() => setShow(false)}
                    show={show}
                    title={"Successfully Submitted"}
                    body={"We have received your contact request and we will respond as quick as possible via email."}
                    subbody={"Thank you for using PRM Assist."}
                    button={"Done"}
                    openButton={() => handleDone()}
                />

                {/* Already Confirmed Modal */}
                <CustomModal
                    hide={() => setShowAlready(false)}
                    show={showAlready}
                    title={"Successfully Submitted Contact"}
                    body={"The contact request has been successfully submitted."}
                    subbody={"Thank you for using PRM Assist."}
                    button={"Done"}
                    openButton={() => setShowAlready(false)}
                />

                {/* Error Modal */}
                <CustomModal
                    hide={() => setShowError(false)}
                    show={showError}
                    title={"Error Sending Contact"}
                    body={"Unfortunately, we ran into an issue trying to send your contact request."}
                    subbody={"Please try again or contact us."}
                    button={"Done"}
                    openButton={() => setShowError(false)}
                />

            </Container>
        </>
    );
};


export default Contact;
